import { use, useCallback } from "react";

import { UserContext } from "../providers/user-context";
import { RevisionStatus } from "../types/schemas";
import { parseError } from "../utils/parse-error";

type GetRevisionStatus = (
  options: {
    transcriptId: string;
    revisionId: string;
  },
  signal?: AbortSignal,
) => Promise<RevisionStatus>;

/**
 * Retrieve the status of the revision.
 */
export function useGetRevisionStatus(): GetRevisionStatus {
  const { user } = use(UserContext);

  const getRevisionStatus = useCallback<GetRevisionStatus>(
    async (options, signal) => {
      const { transcriptId, revisionId } = options;
      const response = await fetch(
        `/app/v2/revisions/${transcriptId}/${revisionId}/status`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          signal,
        },
      );

      if (!response.ok) throw parseError(response.status);
      const json = await response.json();

      return json;
    },
    [user],
  );

  return getRevisionStatus;
}
